const ROLE_VENDOR = 'vendor';
const ROLE_ADMIN = 'admin';
export default {
  vendor: ROLE_VENDOR,
  admin: ROLE_ADMIN,
};
